import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import {
  combineValidators,
  isRequired,
  composeValidators,
  matchesPattern,
} from "revalidate";
import { RootStoreContext } from "../../../app/stores/rootStore";
import TextInput from "../../../app/common/form/TextInput";
import ResetSetId from "./ResetSetId";
import { TestSetStatusEnum } from "../../../app/util/GeneralEnums";

const validate = combineValidators({
  testSetId: composeValidators(
    isRequired({ message: "Campo obligatorio" }),
    matchesPattern(/^[0-9a-fA-F]{8}[-]([0-9a-fA-F]{4}[-]){3}[0-9a-fA-F]{12}$/)({
      message: "Formato esperado: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
    })
  )(),
});

const Step1 = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { testSetStatus, updateTestSet } = rootStore.companyStore;
  const { openModal } = rootStore.modalStore;

  const [testDianForm] = useState({
    testSetId:
      testSetStatus.testSetStatus === TestSetStatusEnum.NoStart
        ? ""
        : testSetStatus?.testSetId,
  });

  const handleFinalFormSubmit = (values: any) => {
    updateTestSet(values);
  };

  return (
    <div>
      <FinalForm
        validate={validate}
        initialValues={testDianForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, values, invalid }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Ingrese el identificador del set de pruebas</label>
              <Field
                name="testSetId"
                component={TextInput}
                readOnly={
                  testSetStatus?.testSetStatus === TestSetStatusEnum.NoStart
                    ? false
                    : true
                }
              />
              {testSetStatus?.testSetId === "" ||
              testSetStatus?.testSetId === null ||
              testSetStatus?.testSetStatus === TestSetStatusEnum.NoStart ? (
                <Button
                  className="ui primary button"
                  color="blue"
                  type="submit"
                  content="Guardar"
                />
              ) : (
                <Button
                  className="ui primary button"
                  color="blue"
                  content="Restablecer"
                  type="button"
                  disabled={
                    testSetStatus?.testSetStatus === TestSetStatusEnum.Sucess
                      ? true
                      : false
                  }
                  onClick={() => {
                    !invalid &&
                      openModal(<ResetSetId />, "Restablecer identificador");
                  }}
                />
              )}
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(Step1);
